import { FC, ReactNode } from 'react';
import { PulsePanel } from '../common/PulsePanel';
import { NoWallet } from './NoWallet';
import { DoDeposit, DepositForm } from './DepositForm';
import { DoApprove, QueryApproval } from '../common/ActionForm';
import { useSiloWeb3 } from '@silo/web3';
import { ActionPanels } from '../common/ActionForm/ActionForm';
import { useIsChartsFeatureOn } from '../common/ActionForm/useIsChartsFeatureOn';
import { ProtocolInstance } from '@silo/types';

type DepositPanelState =
  | { tag: 'noWallet' }
  | { tag: 'loading' }
  // TODO: look into using React suspense for these values
  | { tag: 'loaded'; protocolInstance: ProtocolInstance };
// | { tag: 'frozen' };

const useDepositPanelState = (): DepositPanelState => {
  const { isNotConnected, protocolInstance } = useSiloWeb3();

  if (isNotConnected) return { tag: 'noWallet' };

  if (protocolInstance === undefined) return { tag: 'loading' };

  return { tag: 'loaded', protocolInstance };
};

export interface DepositPanelProps {
  queryApproval: QueryApproval;
  doApprove: DoApprove;
  doDeposit: DoDeposit;
  wallet: ReactNode;
}

export const DepositPanel: FC<DepositPanelProps> = ({ queryApproval, doApprove, doDeposit, wallet }) => {
  const depositPanelState = useDepositPanelState();
  // const depositPanelState = { tag: 'loading' };
  const isChartsTabOn = useIsChartsFeatureOn();

  switch (depositPanelState.tag) {
    case 'noWallet': {
      return <ActionPanels panels={[<NoWallet wallet={wallet} />]} />;
    }
    case 'loading':
    default: {
      return <PulsePanel withCharts={isChartsTabOn} />;
    }
    case 'loaded': {
      const { protocolInstance } = depositPanelState;

      return (
        <DepositForm
          protocolInstance={protocolInstance}
          queryApproval={queryApproval}
          doApprove={doApprove}
          doDeposit={doDeposit}
        />
      );
    }
  }
};
